/*
 * AppReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 */

import { produce } from 'immer';
import {
  INITIALIZE_SESSION_REQUEST,
  SESSION_INITIALIZED,
  SESSION_INITIALIZE_FAILED,
  LOAD_BOM_DATA,
  BOM_DATA_LOADED,
  BOM_DATA_ERROR,
  UPDATE_BOM_DATA,
  SUBMIT_BOM_DATA,
  BOM_DATA_SUBMITTED,
  BOM_SUBMIT_ERROR,
  CLEAR_UPLOADED_DATA,
  SET_LOADING,
  SET_ERROR,
  CLEAR_ERROR,
  SET_SUCCESS,
  CLEAR_SUCCESS,
} from './constants';

// The initial state of the App
export const initialState = {
  session: null,
  sessionLoading: false,
  sessionError: null,
  userDetails: null,
  bomData: null,
  csvData: null,
  loading: false,
  submitting: false,
  error: null,
  success: null,
  tossSuccess: null,
};

/* eslint-disable default-case, no-param-reassign */
const appReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case INITIALIZE_SESSION_REQUEST:
        draft.session = null;
        draft.sessionLoading = true;
        draft.sessionError = null;
        draft.error = null;
        draft.tossSuccess = null;
        draft.userDetails = null;
        break;

      case SESSION_INITIALIZED:
        draft.sessionLoading = false;
        // Handle session initialization success
        // Backend has removed the userId key, so we need to fallback to email
        if (action.payload) {
          draft.session = {
            ...action.payload,
            user: action.payload.user ? {
              ...action.payload.user,
              userId: action.payload.user.userId || action.payload.user.email,
            } : null,
          };
          draft.userDetails = action.payload.user || null;
        } else {
          draft.session = action.payload;
        }
        draft.sessionError = null;
        break;

      case SESSION_INITIALIZE_FAILED:
        draft.sessionLoading = false;
        draft.session = null;
        draft.sessionError = action.error;
        draft.userDetails = null;
        break;


      case LOAD_BOM_DATA:
        draft.loading = true;
        draft.error = null;
        draft.success = null;
        break;

      case BOM_DATA_LOADED:
        draft.loading = false;
        draft.bomData = action.payload.bomData;
        draft.csvData = action.payload.csvData;
        draft.success = action.payload.message;
        break;

      case BOM_DATA_ERROR:
        draft.loading = false;
        draft.error = action.error;
        draft.bomData = null;
        draft.csvData = null;
        break;

      case UPDATE_BOM_DATA:
        draft.bomData = action.payload;
        break;

      case SUBMIT_BOM_DATA:
        draft.submitting = true;
        draft.error = null;
        draft.success = null;
        break;

      case BOM_DATA_SUBMITTED:
        draft.submitting = false;
        draft.success = `BOM data uploaded successfully! Upload ID: ${action.payload.id}`;
        break;

      case CLEAR_UPLOADED_DATA:
        draft.bomData = null;
        draft.csvData = null;
        draft.loading = false;
        draft.submitting = false;
        draft.error = null;
        draft.success = action.payload;
        break;

      case BOM_SUBMIT_ERROR:
        draft.submitting = false;
        draft.error = action.error;
        break;

      case SET_LOADING:
        draft.loading = action.payload;
        break;

      case SET_ERROR:
        draft.error = action.payload;
        break;

      case CLEAR_ERROR:
        draft.error = null;
        break;

      case SET_SUCCESS:
        draft.success = action.payload;
        break;

      case CLEAR_SUCCESS:
        draft.success = null;
        break;
    }
  });

export default appReducer;
